import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import type { CreateRequirementInput } from "@montatec/contracts"
import { CacheKeys } from "../../../shared/consts/keys.consts"
import { requirementsService } from "./requirements.service"

export function useRequirements(categoryId: number | null, tagId: number | null) {
    return useQuery({
        queryKey: CacheKeys.requirements(categoryId!, tagId!),
        queryFn: () => requirementsService.get(categoryId!, tagId!),
        enabled: !!categoryId && !!tagId,
    })
} 

export function useRequirementsMutations() {
    const qc = useQueryClient()
    
    const createRequirement = useMutation({
        mutationFn: ({categoryId, tagId, data } : {categoryId: number, tagId:number, data: CreateRequirementInput}) => 
            requirementsService.create(categoryId, tagId, data),
        onSuccess: (_, vars) => qc.invalidateQueries({ queryKey: CacheKeys.requirements(vars.categoryId, vars.tagId) }),
    })
    
    const deleteRequirement = useMutation({
        mutationFn: ({categoryId, tagId, requirementId} : {categoryId: number, tagId: number, requirementId: number}) => 
            requirementsService.delete(categoryId, tagId, requirementId),
        onSuccess: (_, vars) => qc.invalidateQueries({ queryKey: CacheKeys.requirements(vars.categoryId, vars.tagId) }),
    })

    return { createRequirement, deleteRequirement }
}